var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_188",
    x: 0,
    y: 0,
    width: 50,
    height: 51,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ab53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36953e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    "data-name": "Group 2209",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_188-2",
    "data-name": "Ellipse 188",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "#7ab53f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 16.5,
    rx: 16,
    ry: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 16.5,
    rx: 15,
    ry: 15.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "check_5_",
    "data-name": "check (5)",
    transform: "translate(10.079 11.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5051",
    "data-name": "Path 5051",
    d: "M3.429,78.239a1.135,1.135,0,0,1-.8-.333L.2,75.478a.67.67,0,0,1,0-.947h0a.67.67,0,0,1,.947,0l2.286,2.286,6.048-6.048a.67.67,0,0,1,.947,0h0a.67.67,0,0,1,0,.947l-6.191,6.19A1.135,1.135,0,0,1,3.429,78.239Z",
    transform: "translate(0 -70.573)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.dfd5913b13920a455b0ba828151f0cf0.svg";
export { ForwardRef as ReactComponent };